import React, { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";

import useModal from "hooks/useModal";
import { Lnb } from "./styles";
import { ReactComponent as Logo } from "../../assets/common/logo_vertical.svg";
import { ReactComponent as Bell } from "../../assets/common/icon_bell.svg";
// import { ReactComponent as Coin } from "../../assets/common/icon_coin.svg";
import { ReactComponent as Tab } from "../../assets/common/icon_tab.svg";
import { ReactComponent as Bookmark } from "../../assets/common/icon_bookmark.svg";
// import { ReactComponent as ArrowUp } from "../../assets/common/icon_arrow_up2.svg";
// import { ReactComponent as ArrowDown } from "../../assets/common/icon_arrow_down2.svg";
import MarketingSuggestBox from "components/DataRoom/Detail/MarketingSuggestBox";
import Button from "components/Common/button";
import { useNavigate } from "react-router-dom";
import { getIsUser, getUserInfo } from "utils/utility";
import SigninModal from "components/Signup/Modal/SigninModal";
import { getPhrase } from "apis/site";
import { Viewer } from "@toast-ui/react-editor";
import "@toast-ui/editor/dist/toastui-editor-viewer.css";
import styled from "styled-components";

import useNotificationCountQuery from "hooks/queries/notification/useNotificationCountQuery";
import NotificationModal from "components/Header/Notification/NotificationModal";
import { useTabsQuery } from "hooks/queries/tabs/useTabsQuery";

import LnbUserInfoCard from "components/Mypage/Main/UserInfoCard/LnbUserInfoCard";
import {
  getUserInterestHospital,
  getMyHospital,
  getUserAgency,
  getUserHospital,
} from "apis/users";
import PortfolioGuideModal from "components/Common/Modal/PortfolioGuideModal";
import ChannelGuideModal from "components/Common/Modal/ChannelGuideModal";
import { useAgencyPortfolioQuery } from "hooks/queries/matching/useMatchingQuery";
import { GetPortfolioResponse } from "models/matching";
import QUERY_KEYS from "config/queryKey";

interface DummyDataType {
  marketing: Pick<
    GetHospitalDetailResponse,
    "externalBrandingScoreRank" | "districtName" | "recommendMarketingStrategy"
  >;
}

const DUMY_DATA: DummyDataType = {
  marketing: {
    districtName: "districtName",
    externalBrandingScoreRank: 0,
    recommendMarketingStrategy: "NAVER_BLOG",
  },
};

const AppLnb = () => {
  const isUser = getIsUser();
  const navigate = useNavigate();
  const [content, setContent] = useState<string>("");

  // localStorage에서 hasCheckedModals 상태를 가져옴
  const getHasCheckedModals = () => {
    const userInfo = getUserInfo();
    if (!userInfo?.userId) return false;
    const stored = localStorage.getItem(`hasCheckedModals_${userInfo.userId}`);
    return stored === "true";
  };

  const [hasCheckedModals, setHasCheckedModals] = useState(
    getHasCheckedModals()
  );

  const {
    isOpen: isOpenSigninModal,
    openModal: openSigninModal,
    closeModal: closeSigninModal,
  } = useModal();

  const { data } = useQuery({
    queryKey: ["phrase"],
    queryFn: getPhrase,
  });

  const { data: notificationCount, isFetching } =
    useNotificationCountQuery(isUser);

  const {
    isOpen: isOpenNotificationModal,
    openModal: openNotificationModal,
    closeModal: closeNotificationModal,
  } = useModal();

  useEffect(() => {
    if (data) {
      setContent(data.content);
    }
  }, [data]);

  const { data: availableTabData } = useTabsQuery();

  // const userInfo = localStorage.getItem("userInfo") || "";
  const userInfo = getUserInfo();

  console.log("userInfo", userInfo);

  const { data: interstHospitals } = useQuery({
    queryKey: ["userInterestHospital"],
    queryFn: getUserInterestHospital,
    select: (res) => res.result || res,
  });

  const { data: myHospital } = useQuery({
    queryKey: ["myHospital"],
    queryFn: getMyHospital,
    enabled: userInfo?.userType === "HOSPITAL",
  });

  // 포트폴리오 가이드 모달
  const { data: myAgencyData } = useQuery({
    queryKey: [QUERY_KEYS.user, userInfo?.userType],
    queryFn: getUserAgency,
    enabled: userInfo?.userType === "AGENCY",
  });

  const myAgencyId = myAgencyData?.agencyId || 0;
  const { data: myPortfolioData } = useAgencyPortfolioQuery(Number(myAgencyId));

  const myPortfolios =
    myPortfolioData?.pages.flatMap(
      (page: GetPortfolioResponse) => page.content
    ) ?? [];

  const {
    isOpen: isPortfolioGuideOpen,
    openModal: openPortfolioGuideModal,
    closeModal: closePortfolioGuideModal,
  } = useModal();

  const {
    isOpen: isChannelGuideOpen,
    openModal: openChannelGuideModal,
    closeModal: closeChannelGuideModal,
  } = useModal();

  // 채널 가이드 모달
  const { data: userHospitalData } = useQuery({
    queryKey: ["user"],
    queryFn: getUserHospital,
    enabled: userInfo?.userType === "HOSPITAL",
  });

  // userInfo가 변경될 때 localStorage에서 hasCheckedModals 상태를 다시 읽어옴
  useEffect(() => {
    setHasCheckedModals(getHasCheckedModals());
  }, [userInfo?.userId]);

  // 포트폴리오 가이드 모달 - 로그인 후 한 번만 표시
  useEffect(() => {
    if (hasCheckedModals || !isUser) return;

    if (
      userInfo?.userType === "AGENCY" &&
      myAgencyData &&
      myPortfolios.length === 0
    ) {
      openPortfolioGuideModal();
      const newValue = true;
      setHasCheckedModals(newValue);
      // localStorage에 저장하여 컴포넌트 재마운트 시에도 상태 유지
      if (userInfo?.userId) {
        localStorage.setItem(`hasCheckedModals_${userInfo.userId}`, "true");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [myPortfolios.length, isUser, hasCheckedModals]);

  // 채널 가이드 모달 - 로그인 후 한 번만 표시
  useEffect(() => {
    if (hasCheckedModals || !isUser) return;

    if (userInfo?.userType === "HOSPITAL" && userHospitalData) {
      const { naverBlogURL, naverCafeURL, youtubeURL, instagramId } =
        userHospitalData;

      const allChannelsNull =
        !naverBlogURL && !naverCafeURL && !youtubeURL && !instagramId;

      if (allChannelsNull) {
        openChannelGuideModal();
        const newValue = true;
        setHasCheckedModals(newValue);
        // localStorage에 저장하여 컴포넌트 재마운트 시에도 상태 유지
        if (userInfo?.userId) {
          localStorage.setItem(`hasCheckedModals_${userInfo.userId}`, "true");
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo, userHospitalData, isUser, hasCheckedModals]);

  console.log("myHospital", myHospital);
  return (
    <Lnb className="lnb">
      <div>
        {isUser && !isFetching ? (
          <>
            <div className="myInfo">
              <LnbUserInfoCard />

              <ul>
                {/* <li>
                  <Coin />
                  <span>적립금</span>
                  <p>13,084원</p>
                </li> */}
                <li>
                  <Tab />
                  <span>잔여 Tab</span>
                  <p>
                    {availableTabData
                      ? availableTabData.availableCount.toLocaleString()
                      : 0}
                    개
                  </p>
                </li>
                <li onClick={openNotificationModal}>
                  <Bell />
                  <span>알림</span>
                  <p>
                    {notificationCount
                      ? notificationCount.count > 999
                        ? "999+"
                        : notificationCount.count
                      : 0}
                    개
                  </p>
                </li>
                {isOpenNotificationModal && (
                  <NotificationModal
                    totalCount={notificationCount?.count || null}
                    modalClose={closeNotificationModal}
                  />
                )}
              </ul>

              <div className="buttonWrap">
                <Button
                  colorType="lineGray"
                  onClick={() => navigate("/mypage")}
                >
                  마이페이지
                </Button>
                <Button
                  colorType="primary"
                  onClick={() => navigate("/mypage/membership")}
                >
                  멤버십/열람권
                </Button>
              </div>
            </div>
            {userInfo?.userType === "DOCTOR" ||
              (userInfo?.userType === "HOSPITAL" && (
                <>
                  {userInfo?.userType === "HOSPITAL" && (
                    <div className="ranking">
                      <MarketingSuggestBox
                        data={myHospital || DUMY_DATA.marketing}
                      />
                    </div>
                  )}
                  <div className="bookmark">
                    <div className="title">
                      <p>
                        <Bookmark /> 내 관심 병원
                      </p>
                      {/* <span>전일 대비</span> */}
                    </div>
                    {interstHospitals && interstHospitals.length > 0 ? (
                      <ul>
                        {interstHospitals.map((hospital) => (
                          <li
                            key={hospital.hospitalDataId}
                            onClick={() =>
                              navigate(
                                `/data-room/detail/${hospital.hospitalDataId}`
                              )
                            }
                          >
                            <p>
                              <span className="hospitalName">
                                {hospital.hospitalName}
                              </span>
                              <span className="cityName">
                                ({hospital.cityName} {hospital.districtName})
                              </span>
                            </p>
                            <div>{hospital.rank}위</div>
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <p className="nodata">관심 병원이 없습니다.</p>
                    )}
                  </div>
                </>
              ))}
          </>
        ) : (
          <>
            <Logo />
            <Content>{content && <Viewer initialValue={content} />}</Content>
            <div>
              {/* <Button colorType="lineGray"  onClick={() => navigate("/mypage/membership")}>로그인</Button> */}
              <Button colorType="primary" onClick={openSigninModal}>
                로그인/회원가입
              </Button>

              {/* <Link to="">아이디/비밀번호찾기</Link> */}
            </div>
          </>
        )}
      </div>
      {isOpenSigninModal && <SigninModal modalClose={closeSigninModal} />}

      {isPortfolioGuideOpen && (
        <PortfolioGuideModal modalClose={closePortfolioGuideModal} />
      )}

      {isChannelGuideOpen && (
        <ChannelGuideModal modalClose={closeChannelGuideModal} />
      )}
    </Lnb>
  );
};

export default React.memo(AppLnb);

export const Content = styled.div`
  .toastui-editor-popup-color .tui-colorpicker-container ul {
    width: 152x !important;
    display: block;
  }
  .toastui-editor-popup-body input[type="text"].tui-colorpicker-palette-hex {
    width: 100% !important;
    height: 32px !important;
    padding: 0 12px !important;
    border-radius: 2px !important;
    border: 1px solid #e1e3e9 !important;
  }

  .toastui-editor-contents {
    p {
      margin: 0;
    }
    h1,
    h2 {
      border: none !important;
      margin: 0 !important;
      line-height: 1.4 !important;
    }
    h1 {
      font-size: 28px !important;
    }
    h2 {
      font-size: 24px !important;
    }
    h3 {
      font-size: 20px !important;
    }
    h3,
    h4,
    h5 {
      line-height: 1.4 !important;
      margin-top: 4px !important;
    }
    span {
      font-size: inherit !important;
      line-height: inherit !important;
    }
  }
`;
